export class Event
{
    type: string;
    data: any;
    bubbles: boolean;
    cancelable: boolean;
    target: any;
    currentTarget: any;

    constructor(type: string, data:any = null, bubbles = true, cancelable = false)
    {
        this.type = type;
        this.data = data;
        this.bubbles = bubbles;
        this.cancelable = cancelable;
    }
}
